import request from '../../utils/request';
import {paramSecret} from "../../utils/commonSecret";

export async function AuthSendCode(params) {
    return request('/api/v1/game-store/sendCode',{
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params)),
    })
}

// 使用手机号注册
export async function userRegister(params) {
    return request('/api/v2/front/registerForPcWWW',{
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params)),
    })
}

// 实名认证
export async function userRealAuth(params) {
    return request('/api/v2/front/certificationForPc',{
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(paramSecret(params)),
    })
}
